import {memo, useCallback, useEffect, useState} from "react";
import {Handle, NodeProps, Position} from "@xyflow/react";
import {Metric, TreeNode} from "@/types";
import {BasicCardNode, get_color, render_line} from "@/pages/mindmap/CarNodes/BasicCardNode.tsx";
import {formatCompactNumber} from "@/utils/format.ts";
import ReportModel from "@/pages/mindmap/CarNodes/SummaryNode/ReportModel";
import {fetchReport, downloadPPT} from "@/services/api";
import {COLOR_MAP} from "@/pages/mindmap/constant.ts";
import {useRequest} from "ahooks";
import {useAppStore} from "@/store/appStore.ts";


export const SummaryNode = memo(({data}: NodeProps) => {
    const node: TreeNode = data.node as any;
    const datas: Record<string, Metric> = node.metrics_map || {};

    for (const child of node.children || []) {
        const find_key = `ims_amt_mtd_gap`
        const order_data = child.metrics?.find((m) => m.metric_name === find_key)
        if (order_data) {
            datas[`${child.id}_major_gap`] = order_data;
        }
    }


    const [reportOpen, setReportOpen] = useState(false);

    const selectBatch = useAppStore((state) => state.selectBatch);
    const { data: reportData, loading } = useRequest(
        () => fetchReport(selectBatch?.id || ""),
        {
            ready: reportOpen,
            refreshDeps: [reportOpen, selectBatch?.id],
        }
    );

    const handleDownload = useCallback(async () => {
        try {
            const blob = await downloadPPT(selectBatch?.id || "");
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = `${selectBatch?.id || "unknown"}.pptx`;
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(url);
            document.body.removeChild(a);
        } catch (err) {
            console.log(err)
        }
    }, [selectBatch]);


    return (
        <BasicCardNode
            node={node}
            data={data}
            showChart={true}
            extra={
                <ReportModel
                    root_node={node}
                    reportData={reportData||{}}
                    loading={loading}
                    onOpenChange={(s) => setReportOpen(s)}
                    onDownload={handleDownload}
                />
            }
        >
            <div style={{fontSize: '10px', color: 'rgb(30, 41, 59)'}}>
                <span style={COLOR_MAP['1']}>IMS:</span>
                <div style={{marginLeft: '10px', lineHeight: '1.5'}}>
                    {render_line('ims', 'ytd', datas)}
                    {render_line('ims', 'mtd', datas)}
                    <div style={{color: '#1e293b', fontWeight: 700,marginTop:'5px'}}>Major Gap (MTD):</div>
                    <span>MIP </span>
                    <span style={get_color(`mip_major_gap`, datas)}>
                            {formatCompactNumber(datas[`mip_major_gap`]?.value, 1, 'M')}
                        </span>
                    <span>, AE </span>
                    <span style={get_color(`ae_major_gap`, datas)}>
                            {formatCompactNumber(datas[`ae_major_gap`]?.value, 1, 'M')}
                        </span>
                    <span>, WCH </span>
                    <span style={get_color(`wch_major_gap`, datas)}>
                            {formatCompactNumber(datas[`wch_major_gap`]?.value, 1, 'M')}
                        </span>
                    <span>, BIO </span>
                    <span style={get_color(`bio_major_gap`, datas)}>
                            {formatCompactNumber(datas[`bio_major_gap`]?.value, 1, 'M')}
                        </span>
                </div>
                <br/>
                <span style={COLOR_MAP['1']}>NTS:</span>
                <div style={{marginLeft: '10px'}}>
                    {render_line('nts', 'ytd', datas)}
                    {render_line('nts', 'mtd', datas)}
                    <br/>
                </div>
                <span style={COLOR_MAP['1']}>VBP/Non-VBP:</span>
                <div style={{marginLeft: '10px'}}>
                    {render_line('ims_vbp', 'ytd', datas)}
                    {render_line('ims_nonvbp', 'ytd', datas)}
                </div>
            </div>
        </BasicCardNode>
    );
})
